import { createChallenge } from '../helper/challenge-implementation-helper';
export class SmsChallengeRequest {
    constructor(baseUrl, request) {
        this.baseUrl = baseUrl;
        this.request = request;
    }
    async createChallenge(options) {
        return createChallenge(this.baseUrl, this.request, options);
    }
}
/** @public */
export class SmsOtp {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    withScope(scope) {
        this.scope = scope;
        return this;
    }
    withRequestFrom(requestFrom) {
        this.requestFrom = requestFrom;
        return this;
    }
    withPhoneNumber(countryCode, number) {
        this.phoneNumber = {
            number,
            countryCode,
        };
        return this;
    }
    withEmail(email) {
        this.email = email;
        return this;
    }
    build() {
        const request = {
            authFactor: 'SMS_OTP',
            scope: this.scope,
            requestFrom: this.requestFrom,
            payload: {
                phoneNumber: this.phoneNumber,
                email: this.email,
            },
        };
        return new SmsChallengeRequest(this.baseUrl, request);
    }
}
//# sourceMappingURL=sms-otp.js.map